module.exports = __webpack_public_path__ + "media/images/webpage/hotels/4460/floorguide/course-3-photo-9-2ab734a9e77068c270d1c50a0786edd0.webp";